export default "__VITE_ASSET__De4Chy40__"